import React from "react";
import Card from "../Cards/Card";
import Styles from "./Content.module.css";

export default function Content({ arr = [], title, total, level }) {
  return (
    <div className={Styles.bg}>
      <h1 className={Styles.head}>{title}</h1>

      <div className={Styles.cardWrap}>
        {arr.length > 0 &&
          arr.map((data, i) => (
            <Card
              key={i}
              Name={data.name}
              Year={data.year}
              Branch={data.branch}
              Time={data.time}
              Rank={data.rank}
              Point={data.point}
              Round={data.round}
              Total={total}
              Level={level}
              Photo={data.photo}
              Session={data.session}
              title={data.title}
              contest={data.contest}
            />
          ))}
      </div>
    </div>
  );
}
